import { gql } from 'graphql-request'

export const signIn = gql`
  mutation($username: String!, $password: String!) {
    signin(username: $username, password: $password) {
      id
      token
      full_name 
      user_type {
        id
        type
      }
    }
  }
`

export const logout = gql`
  mutation Logout {
    logout
  }
`
